export default __webpack_public_path__ + "static/media/img-trabajo-9.439c8fe3.png";